import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-museo',
  templateUrl: './card-museo.component.html',
  styleUrls: ['./card-museo.component.scss']
})
export class CardMuseoComponent implements OnInit {
  @Input ('museumObject')
  museumobject: any;

  constructor() { }

  ngOnInit(): void {
  }

}
